var BlankType = /* @__PURE__ */ ((BlankType2) => {
  BlankType2["LIST"] = "list";
  return BlankType2;
})(BlankType || {});

export { BlankType };
//# sourceMappingURL=blank-type.enum.js.map
